import React from "react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    TooltipPortal,
} from "../ui/Tooltip";

interface TruncateTooltipProps {
    button: React.ReactNode;
    text: string;
}

export const TruncateTooltip: React.FC<TruncateTooltipProps> = ({ button, text }) => (
    <TooltipProvider delayDuration={300}>
        <Tooltip>
            <TooltipTrigger asChild>{button}</TooltipTrigger>
            <TooltipPortal>
                <TooltipContent
                    className="text-[11px]"
                    sideOffset={6}
                    side="top"
                    align="start"
                >
                    {text}
                </TooltipContent>
            </TooltipPortal>
        </Tooltip>
    </TooltipProvider>
); 